export const isNil = (value: unknown) => value === null || value === undefined
